/* eslint-disable @typescript-eslint/no-unused-vars */
import { Toolbar } from '@mui/material';
import { useContext } from 'react';
import Drawer from './Drawer';
import CollapseContainer from './CollapseContainer';
import AuthContext from '../../contexts/AuthContext';
import NavigationContext from '../../contexts/NavigationContext';
import useStyles from './styles';
import Button from '../Button';
import Spacer from '../Spacer';

export const Sidebar = (): JSX.Element => {
  const { logout } = useContext(AuthContext);
  const { items, isDrawerMini, setIsDrawerMini } = useContext(NavigationContext);
  const styles = useStyles();

  return (
    <>
      <Drawer open={isDrawerMini} anchor="left" variant="permanent">
        <Toolbar className={styles.toolbar} />

        <div className={styles.container}>
          {items}

          <Spacer />

          <div className={styles.options}>
            {isDrawerMini && (
              <Button variant="text" color="primary" fullWidth onClick={logout}>
                Sair
              </Button>
            )}
          </div>
        </div>
      </Drawer>
      <CollapseContainer isVisible={isDrawerMini} onClick={() => setIsDrawerMini(!isDrawerMini)} />
    </>
  );
};

export default Sidebar;
